import React from "react";
import { UserProfile } from "../../components/UserProfile/index.js";
import Header from "../../components/Header";

const DashboardProfile = () => {
  return (
    <>
      <div className="header-wrapper">
        <Header />
      </div>
      <div style={{ position: "relative" }}>
        <div
          style={{
            height: "81px",
            position: "fixed",
            top: "0px",
            width: "100%",
            zIndex: 1,
          }}
        ></div>
        <UserProfile />
      </div>
    </>
  );
};

export default DashboardProfile;
